import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderLogin from "./HeaderLogin";
// import Logo from "../../../img/alborz-logo-black.png";


export default () => {
  const [display, setDisplay] = React.useState(false);
  const history = useLocation()  
  const tryRequire = (path) => {
    try {
      return require(`${path}`);
    } catch (err) {
      return null;
    }
  };

  return (
    <>
      <a className="navbar-brand mx-0" href="#">
        <a className="navbar-brand" href="#">
          <img src={window.location.origin + "/img/Logo.png"} style={{width:'20rem',height:'4rem'}}/>
        </a>

        {/* اطلس سرمایه گذاری */}
      </a>
      <div className="d-flex gap-15">
        <button
          onClick={() => {
            setDisplay((dis) => !dis);
          }}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
      <div
        className="collapse navbar-collapse"
        style={{ display: display ? "block" : "none" }}
        id="navbarNav"
      >
        <ul className="navbar-nav gap-15">
          <Link to={"/"}>
            <li className={`nav-item ${history.pathname === "/" && `active`}`}>
              <a className="nav-link header-items p-0" href="/">
                <i className="fa fa-home  primary-color"></i>
                خانه
              </a>
            </li>
          </Link>
          <Link to={"/dashboard"}>
            <li
              className={`nav-item ${
                history.pathname === "/dashboard" && `active`
              }`}
            >
              <a className="nav-link header-items p-0">
                <i className="fa fa-dashboard  primary-color"></i>
                پیشخوان سرمایه گذاری
              </a>
            </li>
          </Link>
          {/* <li className="nav-item">
            <a className="nav-link header-items p-0" href="#">
              <i className="fa fa-balance-scale  primary-color"></i>
              قوانین
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link header-items p-0" href="#">
              <i className="fa fa-info-circle  primary-color"></i>
              درباره ما
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link header-items p-0" href="#">
              <i className="fa fa-info  primary-color"></i>
              راهنمای کاربری
            </a>
          </li> */}
          <HeaderLogin />
        </ul>
      </div>
    </>
  );
};
